import React from 'react'

import Loading from '@/app/component/guard/loading'
import createHydrated from '@/app/component/wrapper/hydratable'

import Pricing, { type PricingProps } from './pricing'

type Props = PricingProps & {
  isLoading?: boolean
}

const Plan: React.FC<Props> = (props) => {
  const { isLoading = false } = props

  return (
    <div>
      <Loading isLoading={isLoading}>
        <Pricing {...props} />
      </Loading>
    </div>
  )
}

export default createHydrated(Plan)
